module.exports = __webpack_public_path__ + "static/media/exit-icon.80494bc6.svg";